var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "row" }, [
    _c("div", { staticClass: "col-xs-4 col-sm-12" }, [
      _c("img", { attrs: { src: _vm.talent.profile_image_url } }),
      _vm._v(" "),
      _c("span", { staticClass: "position" }, [_vm._v(_vm._s(_vm.priority))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-xs-8 col-sm-12" }, [
      _c("div", { staticClass: "description" }, [
        _c("h4", [_vm._v(_vm._s(_vm.talent.name))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.talent.profile.tagline))]),
        _vm._v(" "),
        !_vm.$hideSocialMediaReferences
          ? _c(
              "p",
              {
                attrs: {
                  title: `${_vm.talent.profile.highest_followers} followers`,
                },
              },
              [
                _c("i", {
                  class: ["fab", _vm.talent.profile.highest_followers_icon],
                }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("abbreviatedNumber")(
                        _vm.talent.profile.highest_followers
                      )
                    ) +
                    " followers\n      "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: { href: "" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.handleRemoveCallback.apply(null, arguments)
              },
            },
          },
          [
            _vm._v("\n        Remove\n        "),
            _vm.removingShortlistedTalent
              ? _c("i", { staticClass: "fa fa-circle-o-notch fa-spin fa-fw" })
              : _vm._e(),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }